import React from 'react';
import {
  Calculator, TrendingUp, Ruler, Clock, BookOpen, Droplets, FileText, Home, Car,
  Infinity, FunctionSquare, ChevronsUp, DivideCircle, Divide, LineChart, Asterisk,
  Combine, Shuffle, Percent, ArrowLeftRight, CircleDot, Coins, Square, Cuboid,
  MapPin, Calendar, CalendarDays, GraduationCap, BookCheck,
  Weight, Scale, CircleDashed, Activity, Flame, PieChart, Beef, Wheat, Sprout,
  CalendarHeart, Code, Key, Palette, Smartphone, Image, RefreshCw, Star,
  ThermometerSun, Fuel, Music, Box, Stethoscope, Wand2
} from 'lucide-react';

export interface CalculatorItem {
  id: string;
  name: string;
  icon: React.ReactNode;
  description?: string;
}

export interface CalculatorCategory {
  id: string;
  title: string;
  icon: React.ReactNode;
  calculators: CalculatorItem[];
}

export const calculatorCategories: CalculatorCategory[] = [
  {
    id: 'math',
    title: 'Matematik',
    icon: React.createElement(Calculator, { size: 20, className: "text-indigo-400" }),
    calculators: [
      { id: 'gcdlcm', name: 'EBOB ve EKOK', icon: React.createElement(Infinity, { size: 20, className: "text-indigo-400" }) },
      { id: 'sqrt', name: 'Karekök Hesaplama', icon: React.createElement(FunctionSquare, { size: 20, className: "text-indigo-400" }) },
      { id: 'power', name: 'Üslü Sayılar', icon: React.createElement(ChevronsUp, { size: 20, className: "text-indigo-400" }) },
      { id: 'modular', name: 'Modüler Hesaplama', icon: React.createElement(DivideCircle, { size: 20, className: "text-indigo-400" }) },
      { id: 'primeFactor', name: 'Asal Çarpanlar', icon: React.createElement(Divide, { size: 20, className: "text-indigo-400" }) },
      { id: 'stdDev', name: 'Standart Sapma', icon: React.createElement(LineChart, { size: 20, className: "text-indigo-400" }) },
      { id: 'factorial', name: 'Faktöriyel', icon: React.createElement(Asterisk, { size: 20, className: "text-indigo-400" }) },
      { id: 'combination', name: 'Kombinasyon', icon: React.createElement(Combine, { size: 20, className: "text-indigo-400" }) },
      { id: 'permutation', name: 'Permütasyon', icon: React.createElement(Shuffle, { size: 20, className: "text-indigo-400" }) },
      { id: 'percentage', name: 'Yüzde Hesaplama', icon: React.createElement(Percent, { size: 20, className: "text-indigo-400" }) },
      { id: 'ratio', name: 'Oran Hesaplama', icon: React.createElement(ArrowLeftRight, { size: 20, className: "text-indigo-400" }) },
      { id: 'random', name: 'Rastgele Sayı Üretici', icon: React.createElement(Asterisk, { size: 20, className: "text-blue-400" }), description: 'Rastgele sayı üretin.' },
      { id: 'pronunciation', name: 'Sayı Okunuşu', icon: React.createElement(FileText, { size: 20, className: "text-blue-400" }) },
    ]
  },
  {
    id: 'finance',
    title: 'Finans',
    icon: React.createElement(TrendingUp, { size: 20, className: "text-emerald-400" }),
    calculators: [
      { id: 'cryptoCalculator', name: 'Kripto Kâr/Zarar Hesaplama', icon: React.createElement(Coins, { size: 20, className: "text-emerald-400" }), description: 'Kripto alım satım işlemlerinizin kâr/zarar durumunu hesaplayın.' },
      { id: 'cryptoCurrencyConverter', name: 'Kripto Para Dönüştürücü', icon: React.createElement(Coins, { size: 20, className: "text-emerald-400" }), description: 'Farklı kripto para birimleri arasında canlı dönüşüm yapın.' },
      { id: 'goldCalculator', name: 'Altın Hesaplama', icon: React.createElement(Coins, { size: 20, className: "text-emerald-400" }) },
      { id: 'tlDolarCalculator', name: 'TL Dolar Çevirici', icon: React.createElement(ArrowLeftRight, { size: 20, className: "text-emerald-400" }), description: 'Anlık saliselik güncellenen kura göre TL ve dolar arasında dönüşüm yapın.' },
      { id: 'dollarEuro', name: 'Dolar Euro Çevirici', icon: React.createElement(ArrowLeftRight, { size: 20, className: "text-emerald-400" }), description: 'Dolar ve Euro arasındaki dönüşümü yapın.' },
      { id: 'euroDolarCalculator', name: 'Euro Dolar Dönüştürücü', icon: React.createElement(ArrowLeftRight, { size: 20, className: "text-emerald-400" }), description: 'Anlık saliselik güncellenen kura göre euro ve dolar arasında dönüşüm yapın.' },
      { id: 'tlEuroCalculator', name: 'TL Euro Çevirici', icon: React.createElement(ArrowLeftRight, { size: 20, className: "text-emerald-400" }), description: 'Anlık saliselik güncellenen kura göre TL ve euro arasında dönüşüm yapın.' },
      { id: 'priceIncrease', name: 'Zam Hesaplama', icon: React.createElement(TrendingUp, { size: 20, className: "text-emerald-400" }) }
    ]
  },
  {
    id: 'islamic',
    title: 'İslami Hesaplamalar',
    icon: React.createElement(Coins, { size: 20, className: "text-emerald-400" }),
    calculators: [
      { id: 'zekat', name: 'Zekat Hesaplama', icon: React.createElement(Coins, { size: 20, className: "text-emerald-400" }) },
    ]
  },
  {
    id: 'geometry',
    title: 'Geometri',
    icon: React.createElement(Square, { size: 20, className: "text-amber-400" }),
    calculators: [
      { id: 'area', name: 'Alan Hesaplama', icon: React.createElement(Square, { size: 20, className: "text-amber-400" }) },
      { id: 'volume', name: 'Hacim Hesaplama', icon: React.createElement(Cuboid, { size: 20, className: "text-amber-400" }) },
      { id: 'perimeter', name: 'Çevre Hesaplama', icon: React.createElement(Square, { size: 20, className: "text-amber-400" }) },
      { id: 'goldenRatio', name: 'Altın Oran Hesaplama', icon: React.createElement(CircleDot, { size: 20, className: "text-indigo-400" }), description: 'İki miktarın altın orana uygunluğunu hesaplayın.' },
    ]
  },
  {
    id: 'measurement',
    title: 'Ölçüm',
    icon: React.createElement(Ruler, { size: 20, className: "text-amber-400" }),
    calculators: [
      { id: 'squareMeter', name: 'Metrekare Hesaplama', icon: React.createElement(Square, { size: 20, className: "text-amber-400" }) },
      { id: 'inch', name: 'İnç Hesaplama', icon: React.createElement(Ruler, { size: 20, className: "text-amber-400" }) },
      { id: 'mile', name: 'Mil Kaç Km', icon: React.createElement(MapPin, { size: 20, className: "text-amber-400" }) },
      { id: 'baseConversion', name: 'Taban Hesaplama', icon: React.createElement(Calculator, { size: 20, className: "text-amber-400" }) },
      { id: 'desiCalculator', name: 'Desi Hesaplama', icon: React.createElement(Box, { size: 20, className: "text-amber-400" }), description: 'Kargo gönderileriniz için hacimsel ağırlık (desi) hesaplayın.' },
    ]
  },
  {
    id: 'time',
    title: 'Zaman',
    icon: React.createElement(Clock, { size: 20, className: "text-green-400" }),
    calculators: [
      { id: 'daysCalculator', name: 'Kaç Gün Oldu Hesaplama', icon: React.createElement(Calendar, { size: 20, className: "text-green-400" }) },
      { id: 'birthDate', name: 'Doğum Tarihi Hesaplama', icon: React.createElement(Calendar, { size: 20, className: "text-pink-400" }) },
      { id: 'yasHesaplama', name: 'Yaş Hesaplama', icon: React.createElement(CalendarDays, { size: 20, className: "text-purple-400" }), description: 'Doğum tarihinize göre yaşınızı yıl, ay ve gün olarak hesaplayın.' },
      { id: 'yoldaGecenZaman', name: 'Yolda Geçen Zaman', icon: React.createElement(Clock, { size: 20, className: "text-orange-400" }), description: 'Hayatınızın ne kadarını yollarda geçirdiğinizi hesaplayın.' }
    ]
  },
  {
    id: 'education',
    title: 'Eğitim',
    icon: React.createElement(BookOpen, { size: 20, className: "text-indigo-400" }),
    calculators: [
      { id: 'gradeCalculator', name: 'Ders Notu Hesaplama', icon: React.createElement(BookOpen, { size: 20, className: "text-indigo-400" }), description: 'Yazılı ve sözlü notlarınızla dönem puanınızı hesaplayın.' },
      { id: 'gpaCalculator', name: 'Vize Final Ortalama Hesaplama', icon: React.createElement(BookOpen, { size: 20, className: "text-indigo-400" }) },
      { id: 'liseMezuniyet', name: 'Lise Mezuniyet Puanı', icon: React.createElement(GraduationCap, { size: 20, className: "text-indigo-400" }), description: '9, 10, 11 ve 12. sınıf YBP ile diploma notunuzu hesaplayın.' },
      { id: 'obpCalculator', name: 'OBP Hesaplama', icon: React.createElement(GraduationCap, { size: 20, className: "text-indigo-400" }) },
      { id: 'tusPuan', name: 'TUS Puan Hesaplama', icon: React.createElement(Stethoscope, { size: 20, className: "text-indigo-400" }), description: 'TTB ve KTB doğru sayılarınızla TUS puanınızı tahmin edin.' },
      { id: 'tytPuan', name: 'TYT Puan Hesaplama', icon: React.createElement(BookCheck, { size: 20, className: "text-indigo-400" }), description: 'Türkçe, Matematik, Sosyal, Fen doğru ve diploma notu ile TYT puanınızı hesaplayın.' },
      { id: 'animalSounds', name: 'Hayvan Sesleri', icon: React.createElement(Music, { size: 20, className: "text-indigo-400" }), description: 'Çocuklar için gerçek hayvan sesleri dinle.' }
    ]
  },
  {
    id: 'health',
    title: 'Sağlık',
    icon: React.createElement(Droplets, { size: 20, className: "text-blue-400" }),
    calculators: [
      { id: 'waterNeed', name: 'Günlük Su İhtiyacı', icon: React.createElement(Droplets, { size: 20, className: "text-blue-400" }) },
      { id: 'idealWeight', name: 'İdeal Kilo Hesaplama', icon: React.createElement(Weight, { size: 20, className: "text-green-400" }) },
      { id: 'bmi', name: 'Vücut Kitle Endeksi Hesaplama', icon: React.createElement(Scale, { size: 20, className: "text-blue-400" }) },
      { id: 'bodyFat', name: 'Vücut Yağ Oranı Hesaplama', icon: React.createElement(Percent, { size: 20, className: "text-orange-400" }) },
      { id: 'waistHipRatio', name: 'Bel/Kalça Oranı', icon: React.createElement(CircleDashed, { size: 20, className: "text-purple-400" }) },
      { id: 'bmr', name: 'Bazal Metabolizma Hızı', icon: React.createElement(Activity, { size: 20, className: "text-red-400" }) },
      { id: 'calorieNeed', name: 'Günlük Kalori İhtiyacı', icon: React.createElement(Flame, { size: 20, className: "text-orange-400" }) },
      { id: 'macroNutrient', name: 'Makro Besin İhtiyacı', icon: React.createElement(PieChart, { size: 20, className: "text-purple-400" }) },
      { id: 'proteinNeed', name: 'Protein İhtiyacı', icon: React.createElement(Beef, { size: 20, className: "text-red-400" }) },
      { id: 'carbNeed', name: 'Karbonhidrat İhtiyacı', icon: React.createElement(Wheat, { size: 20, className: "text-amber-400" }) },
      { id: 'fatNeed', name: 'Yağ İhtiyacı', icon: React.createElement(Sprout, { size: 20, className: "text-green-500" }) },
      { id: 'babyHeight', name: 'Bebek Boyu Hesaplama', icon: React.createElement(Ruler, { size: 20, className: "text-pink-400" }) },
      { id: 'babyWeight', name: 'Bebek Kilosu Hesaplama', icon: React.createElement(Weight, { size: 20, className: "text-pink-400" }) },
      { id: 'metabolizmaYasi', name: 'Metabolizma Yaşı Hesaplama', icon: React.createElement(Activity, { size: 20, className: "text-teal-400" }), description: 'VKİ tabanlı tahmini metabolizma yaşınızı ve önerileri öğrenin.' },
      { id: 'yumurtlamaDonemi', name: 'Yumurtlama Dönemi Hesaplama', icon: React.createElement(CalendarHeart, { size: 20, className: "text-pink-400" }), description: 'Son adet tarihi ve döngü sürenize göre doğurganlık pencerenizi tahmin edin.' },
      { id: 'braSize', name: 'Sütyen Ölçüsü Hesaplama', icon: React.createElement(Ruler, { size: 20, className: "text-pink-400" }), description: 'Doğru sütyen bedeninizi ve cup ölçünüzü kolayca hesaplayın.' }
    ]
  },
  {
    id: 'tools',
    title: 'Yardımcı Araçlar',
    icon: React.createElement(FileText, { size: 20, className: "text-blue-400" }),
    calculators: [
      { id: 'wordCount', name: 'Kelime Sayısı Hesaplama', icon: React.createElement(FileText, { size: 20, className: "text-blue-400" }) },
      { id: 'loremIpsum', name: 'Lorem Ipsum Üretici', icon: React.createElement(FileText, { size: 20, className: "text-blue-400" }), description: 'Web tasarım ve yazılım projeleri için Lorem Ipsum metni oluşturun.' },
      { id: 'dataUnitConverter', name: 'Veri Birimi Dönüştürücü', icon: React.createElement(ArrowLeftRight, { size: 20, className: "text-blue-400" }) },
      { id: 'weightUnitConverter', name: 'Ağırlık Birimi Dönüştürücü', icon: React.createElement(ArrowLeftRight, { size: 20, className: "text-blue-400" }) },
      { id: 'energyUnitConverter', name: 'Enerji Birimi Dönüştürücü', icon: React.createElement(ArrowLeftRight, { size: 20, className: "text-blue-400" }) },
      { id: 'lengthUnitConverter', name: 'Uzunluk Birimi Dönüştürücü', icon: React.createElement(ArrowLeftRight, { size: 20, className: "text-blue-400" }) },
      { id: 'jsonFormatter', name: 'JSON Biçimlendirici ve Doğrulayıcı', icon: React.createElement(Code, { size: 20, className: "text-blue-400" }), description: 'JSON verilerinizi biçimlendirin, doğrulayın ve düzenleyin.' },
      { id: 'textCaseConverter', name: 'Metin Harf Dönüştürücü', icon: React.createElement(FileText, { size: 20, className: "text-blue-400" }), description: 'Metninizi büyük harf, küçük harf, camelCase ve diğer formatlara dönüştürün.' },
      { id: 'urlEncodeDecoder', name: 'URL Encode Decode Çevirici', icon: React.createElement(ArrowLeftRight, { size: 20, className: "text-blue-400" }), description: 'URL\'lerdeki özel karakterleri güvenli formata çevirin.' },
      { id: 'base64EncodeDecode', name: 'Base64 Encode Decode Çevirici', icon: React.createElement(FileText, { size: 20, className: "text-blue-400" }), description: 'Metinleri ve dosyaları Base64 formatına kodlayın veya çözün.' },
      { id: 'uuidGenerator', name: 'UUID Generator', icon: React.createElement(CircleDot, { size: 20, className: "text-blue-400" }), description: 'Veritabanı ve API projeleriniz için benzersiz UUID kimlik üretin.' },
      { id: 'hashCalculator', name: 'Hash Hesaplayıcı - MD5 SHA256 Hash Üretici', icon: React.createElement(Activity, { size: 20, className: "text-blue-400" }), description: 'MD5, SHA-256, SHA-512 hash algoritmaları ile güvenli hash değerleri üretin.' },
      { id: 'qrCodeGenerator', name: 'QR Kod Oluşturucu - Online QR Code Generator', icon: React.createElement(Smartphone, { size: 20, className: "text-blue-400" }), description: 'Metinleri, URL\'leri ve verileri QR koda çevirin. Mobil cihazlarla kolay okuma.' },
      { id: 'imageResizer', name: 'Görsel Boyutlandırma - Online Image Resizer', icon: React.createElement(Image, { size: 20, className: "text-blue-400" }), description: 'Fotoğraflarınızı farklı boyutlara dönüştürün. Sosyal medya ve web için optimize edin.' },
      { id: 'textFormatter', name: 'Text Formatter - Metin Biçimlendirici ve Düzenleyici', icon: React.createElement(FileText, { size: 20, className: "text-blue-400" }), description: 'Metinlerinizi düzenleyin. Boşluk temizleme, satır düzenleme ve metin analizi.' },
      { id: 'passwordGenerator', name: 'Password Generator - Güçlü Şifre Üreticisi', icon: React.createElement(Key, { size: 20, className: "text-blue-400" }), description: 'Güvenli ve güçlü şifreler oluşturun. Hesap güvenliğinizi artırın.' },
      { id: 'colorPicker', name: 'Color Picker - Renk Seçici ve Kod Üretici', icon: React.createElement(Palette, { size: 20, className: "text-blue-400" }), description: 'Renkleri seçin ve farklı formatlarda kod üretin. Web tasarım için ideal.' },
      { id: 'timeZoneConverter', name: 'Time Zone Converter - Saat Dilimi Dönüştürücü', icon: React.createElement(Clock, { size: 20, className: "text-blue-400" }), description: 'Farklı saat dilimlerini dönüştürün. Global iş ve seyahat için ideal.' },
      { id: 'cssMinifier', name: 'CSS Minifier - CSS Sıkıştırıcı ve Optimize Edici', icon: React.createElement(Code, { size: 20, className: "text-blue-400" }), description: 'CSS kodlarınızı sıkıştırın ve optimize edin. Web performansını artırın.' },
      { id: 'jsBeautifier', name: 'JavaScript Beautifier - JS Kod Düzenleyici ve Formatter', icon: React.createElement(Code, { size: 20, className: "text-blue-400" }), description: 'JavaScript kodlarınızı düzenleyin ve formatla. Kod okunabilirliğini artırın.' },
      { id: 'textToASCII', name: 'Text to ASCII Art - Metin Sanatı Dönüştürücü', icon: React.createElement(Code, { size: 20, className: "text-blue-400" }), description: 'Metinlerinizi sanatsal ASCII karakterlere dönüştürün. Yaratıcı tasarımlar oluşturun.' },
      { id: 'imageCompressor', name: 'Image Compressor - Görsel Sıkıştırıcı ve Optimize Edici', icon: React.createElement(Image, { size: 20, className: "text-blue-400" }), description: 'Resimlerinizi sıkıştırın ve optimize edin. Web performansını artırın.' },
      { id: 'imageFormatConverter', name: 'Görsel Format Dönüştürücü - Resim Formatı Değiştirici', icon: React.createElement(RefreshCw, { size: 20, className: "text-blue-400" }), description: 'Resim formatlarını dönüştürün. JPEG, PNG, WebP arası çeviri yapın.' },
      { id: 'faviconGenerator', name: 'Favicon Oluşturucu - Website Simgesi Üretici', icon: React.createElement(Star, { size: 20, className: "text-blue-400" }), description: 'Web siteniz için profesyonel favicon simgeleri oluşturun.' },
      { id: 'turkishCharCleaner', name: 'Türkçe Karakter Temizleme ve Düzeltme', icon: React.createElement(Wand2, { size: 20, className: "text-blue-400" }), description: 'Bozuk Türkçe karakterleri düzeltin veya metni İngilizce karakterlere çevirin.' },
    ]
  },
  {
    id: 'homeAppliances',
    title: 'Ev ve Yaşam',
    icon: React.createElement(Home, { size: 20, className: "text-lime-400" }),
    calculators: [
      {
        id: 'klimaBtu',
        name: 'Klima BTU Hesaplama',
        icon: React.createElement(ThermometerSun, { size: 24, className: "text-sky-400" }),
        description: 'Odanız için ideal klima BTU değerini ve kapasitesini hesaplayın.'
      },
      {
        id: 'elektrikFaturasi',
        name: 'Elektrik Faturası Hesaplama',
        icon: React.createElement(Flame, { size: 24, className: "text-yellow-400" }),
        description: 'Aylık elektrik tüketiminize göre fatura tutarınızı hesaplayın.'
      },
      {
        id: 'dogalgazFaturasi',
        name: 'Doğalgaz Faturası Hesaplama',
        icon: React.createElement(Flame, { size: 24, className: "text-orange-400" }),
        description: 'Kademeli tarife ile doğalgaz fatura tutarınızı hesaplayın.'
      }
    ]
  },
  {
    id: 'automotive',
    title: 'Otomotiv',
    icon: React.createElement(Car, { size: 20, className: "text-red-400" }),
    calculators: [
      {
        id: 'fuelConsumption',
        name: 'Yakıt Tüketimi Hesaplama - Araç Yakıt Masrafı Hesaplayıcı',
        icon: React.createElement(Fuel, { size: 24, className: "text-red-400" }),
        description: 'Aracınızın yakıt tüketimini ve seyahat maliyetini hesaplayın.'
      }
    ]
  },
  {
    id: 'income',
    title: 'Kazanç Tahminleri',
    icon: React.createElement(TrendingUp, { size: 20, className: "text-green-400" }),
    calculators: [
      {
        id: 'dailyRentalIncome',
        name: 'Günlük Ev-Bungalov Kiralama Kazanç Hesaplama',
        icon: React.createElement(Home, { size: 24, className: "text-green-400" }),
        description: 'Günlük ev ve bungalov kiralama işinizden elde edeceğiniz net kazancı hesaplayın.'
      }
    ]
  }
];

// Sidebar için özel kategori tanımları (Ana sayfa ve sidebar arasındaki farkları yönetmek için)
export const sidebarCategories = [
  {
    id: 'home',
    title: 'Ana Sayfa',
    icon: React.createElement(Home, { size: 20, className: "text-cyan-400" }),
    calculators: [
      { id: 'home', name: 'Ana Sayfa', icon: React.createElement(Home, { size: 20, className: "text-cyan-400" }) },
      { id: 'calcApp', name: 'Hesap Makinesi', icon: React.createElement(Calculator, { size: 20, className: "text-cyan-400" }) }
    ]
  },
  ...calculatorCategories
];

// Yardımcı fonksiyonlar
export const getCategoryById = (id: string): CalculatorCategory | undefined => {
  return calculatorCategories.find(category => category.id === id);
};

export const getCalculatorById = (id: string): CalculatorItem | undefined => {
  for (const category of calculatorCategories) {
    const calculator = category.calculators.find(calc => calc.id === id);
    if (calculator) return calculator;
  }
  return undefined;
};

export const getAllCalculators = (): CalculatorItem[] => {
  return calculatorCategories.flatMap(category => category.calculators);
};

export const getCalculatorsByCategory = (categoryId: string): CalculatorItem[] => {
  const category = getCategoryById(categoryId);
  return category ? category.calculators : [];
};
